import {
  Game,
  GameInformationTypeEnum,
  GameMetadataTagsInformation,
} from "entities/game/types";
import isEmpty from "lodash/isEmpty";
import { ComboGroupedElement } from "shared/components/Combobox/type";
import { COLOR_GREEN, COLOR_GREY_3 } from "shared/theme/colors";

export const getChipColor = (status: boolean) => {
  if (status) {
    return COLOR_GREEN;
  }

  return COLOR_GREY_3;
};

export const getTagsCount = (game: Game) => {
  const tags = game.tags ?? [];
  const themeTags = game.themeTags ?? [];
  const metadataFeatures = game.metadata?.features ?? [];

  const metadataInformation =
    game.metadata?.gameInformation?.filter(
      (item) =>
        GameMetadataTagsInformation.includes(
          item.type as GameInformationTypeEnum,
        ) && !isEmpty(item.value),
    ) ?? [];

  return (
    tags.length +
    themeTags.length +
    metadataFeatures.length +
    metadataInformation.length
  );
};

export const getFilteredTagsBySearchValue = (
  tags: ComboGroupedElement[],
  searchValue: string,
) => {
  const filteredTagsBySearchValue: ComboGroupedElement[] = tags
    .filter((tag) => {
      return tag.options.some((option) =>
        option.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    })
    .map((tag) => ({
      ...tag,
      options: tag.options.filter((option) =>
        option.name.toLowerCase().includes(searchValue.toLowerCase()),
      ),
    }));

  return filteredTagsBySearchValue;
};
